import { SxProps, Theme } from '@mui/material';
import { getDenseResponsiveFontSize } from 'theme/watchdutyTheme.utils';

/** Share incident CTAs — fixed label size at all text scales. */
export const geoEventShareButtonSx: SxProps<Theme> = {
  fontSize: getDenseResponsiveFontSize('1rem'),
};
